export default "__VITE_PUBLIC_ASSET__cadb4ada__"